<template>
  <div>
    <v-btn
      v-if="$i18n.locale === 'en'"
      color="transparent"
      depressed
      height="42"
      class="px-0 me-6 no-background-hover"
      :class="!isAuthenticated ? 'pb-1' : ''"
      style="text-transform: unset; min-width: 0"
      @click="changeLocale('ar')"
    >
      <span class="text-h5">ع</span>
    </v-btn>

    <v-btn
      v-else
      color="transparent"
      depressed
      height="45"
      class="px-0 me-6 no-background-hover"
      style="text-transform: unset; min-width: 0"
      @click="changeLocale('en')"
    >
      <span class="text-h5">En</span>
    </v-btn>

    <!-- <v-menu
      bottom
      origin="center center"
      transition="scale-transition"
      style="z-index: 999999"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          id="no-background-hover"
          color="transparent"
          depressed
          v-bind="attrs"
          v-on="on"
          class="pa-0 body-1"
          style="text-transform: unset"
        >
          <span class="text-h5">ع</span>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          class="hand-cursor"
          v-for="(language, index) in languages"
          :key="index"
        >
          <v-list-item-title @click="changeLocale(language.language)">
            {{
              $vuetify.breakpoint.mdAndDown ? language.language : language.title
            }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu> -->
  </div>
</template>

<script>
import i18n from "../../../plugins/i18n";
import { saveLanguage, setLanguage } from "../util/languageHelper";

export default {
  data: () => {
    return {
      languages: [
        {
          language: "en",
          title: "English",
        },
        {
          language: "ar",
          title: "عربى",
        },
      ],
      selectedLanguage: i18n.locale,
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
  },
  methods: {
    changeLocale(locale) {
      setLanguage(locale);
      saveLanguage(locale);
      this.$vuetify.rtl = locale === "ar";
      location.reload();
    },
  },
};
</script>
